export class Webhook {
    constructor({
                    //attributes
                    id= null,
                    company_id= null,
                    name= '',
                    callback= '',
                    type= 0,
                    created_at= new Date(),
                    updated_at= new Date(),
                    deleted_at= null,
                } = {}) {

        //fill attributes
        this.id=id;
        this.company_id=company_id;
        this.name=name;
        this.callback=callback;
        this.type=type;
        this.created_at=created_at;
        this.updated_at=updated_at;
        this.deleted_at=deleted_at;
    }

    get type_name(){
        return Webhook.typeNameByCode(this.type)
    }

    static typeNameByCode(code){
        switch (code){
            case 0:
                return "Envio de Pedido";
            case 1:
                return "Importação de condições de pagamento";
            case 2:
                return "Envio de Pedido de Compra";
            case 3:
                return "Lançar Contas a Pagar";
            case 4:
                return "Atualização de Orçamentos";
            case 5:
                return "Consulta de Estoque";
        }
        return "";
    }

}

export function createWebhook(data={}) {
    return Object.freeze(new Webhook(data));
}